import { ResourceEntityType } from '../../model/resources/ResourceEntityType';
import { ProcessingMetrics } from '../../model/metrics/ProcessingMetrics';
import { Factory } from '../Factory';
import { BaseProcessingMetricsService } from './BaseProcessingMetricsService';
import { IConfigService } from '../config';
import { ResourceWrapperService } from '../utilities/ResourceWrapperService';

export class PostProcessingMetricsService extends BaseProcessingMetricsService {
  private projectCommunicationPatterns;
  private collectionCommunicationPatterns;
  private allProjectMetrics;
  private allCollectionMetrics;
  private projectNamedEntities;
  private collectionNamedEntities;

  constructor($resource: angular.resource.IResourceService, configService: IConfigService, resourceWrapperService: ResourceWrapperService) {
    super($resource, configService, resourceWrapperService);
    let baseUrl = configService.getServerBaseUrlForResource();

    this.projectCommunicationPatterns = this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/postprocessingmetrics/communication`, {id: "@id"}));
    this.collectionCommunicationPatterns = this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/postprocessingmetrics/communication`, {
      id: "@id",
      collectionId: "@collectionId"
    }));
    this.projectNamedEntities = this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/postprocessingmetrics/entity/:type`, {id: "@id", type: "@type"}));
    this.collectionNamedEntities = this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/postprocessingmetrics/entity/:type`, {
      id: "@id",
      collectionId: "@collectionId",
      type: "@type"
    }));
    this.allProjectMetrics = this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/postprocessingmetrics`, {id: "@id"}, {
      query: {
        method: "GET",
        isArray: false
      }
    }));
    this.allCollectionMetrics = this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/postprocessingmetrics`, {
      id: "@id",
      collectionId: "@collectionId"
    }, {query: {method: "GET", isArray: false}}));

    this.projectMetricsByExtension = new ProcessingMetrics(
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/postprocessingmetrics/extension/size`, {id: "@id"})),
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/postprocessingmetrics/extension/count`, {id: "@id"})),
      this.resourceWrapperService
    );

    this.projectMetricsByType = new ProcessingMetrics(
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/postprocessingmetrics/type/size`, {id: "@id"})),
      this.resourceWrapperService.WrapActions($resource(configService.getServerBaseUrlForResource() + '/project/:id/postprocessingmetrics/type/count', {'id': '@id'})),
      this.resourceWrapperService
    );

    this.collectionMetricsByExtension = new ProcessingMetrics(
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/postprocessingmetrics/extension/size`, {
        id: "@id",
        collectionId: "@collectionId"
      })),
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/postprocessingmetrics/extension/count`, {
        id: "@id",
        collectionId: "@collectionId"
      })),
      this.resourceWrapperService
    );

    this.collectionMetricsByType = new ProcessingMetrics(
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/postprocessingmetrics/type/size`, {
        id: "@id",
        collectionId: "@collectionId"
      })),
      this.resourceWrapperService.WrapActions($resource(`${baseUrl}/project/:id/collection/:collectionId/postprocessingmetrics/type/count`, {
        id: "@id",
        collectionId: "@collectionId"
      })),
      this.resourceWrapperService
    );

  }

  public async GetCommunicationPatterns(projectId: string, count: number, collectionId?: string)  {
    return collectionId ? this.collectionCommunicationPatterns.query({
      id: projectId,
      collectionId: collectionId,
      count: count
    }).$promise : this.projectCommunicationPatterns.query({id: projectId, count: count}).$promise;
  }

  public async GetNamedEntities(projectId: string, resourceEntityType: ResourceEntityType, collectionId?: string)  {
    return collectionId ? this.collectionNamedEntities.query({
      id: projectId,
      collectionId: collectionId,
      type: resourceEntityType.valueOf()
    }).$promise : this.projectNamedEntities.query({id: projectId, type: resourceEntityType.valueOf()}).$promise;
  }

  public async GetAllMetrics(projectId: string, collectionId?: string) {
    return collectionId ? this.allCollectionMetrics.query({
      id: projectId,
      collectionId: collectionId,
    }).$promise : this.allProjectMetrics.query({id: projectId}).$promise;
  }
}


frontendApp.factory("PostProcessingMetricsService", ["$resource", "ConfigService", "ResourceWrapperService", Factory.Create(PostProcessingMetricsService)]);
